const $settings=require('./variables'), $joiners=$settings.joiners,$comparators=Object.values($settings.comparators);

class Comparaison{
	constructor(comparaison){
		let comp={},
			obj={
				leftSide:'', 
				rightSide:'', 
				comparator:'==',
				next_joiner:{value:""}
			};

		if(typeof comparaison ==='string'){

			let comparator=alt($comparators.filter(el=>comparaison.includes(el.val)),$comparators),
				cp=comparator, tab=comparaison.split(cp.val);
			comp={leftSide:alt(tab.shift(),''), rightSide:alt(tab.pop(),''), comparator:cp};
		}else{
			comp=comparaison;
		}
		comp=Object.assign(obj,comp);
		for (let el in comp) {
			this[el]=comp[el];
		}
	}

	get exp(){
		return this.leftSide+this.comparator_value+this.rightSide+alt(this.next_joiner_val,"");
	}
	get comparator_value(){
		return this.comparator.val;
	}
	get next_joiner_val(){
		return this.next_joiner.value;
	}
};

class Condition{
	constructor(condition){
		let funct=condition.slice(0,condition.indexOf('(')),
			comparaison=condition.slice(condition.indexOf('(')+1,-1).split('||')[0], 
			joiner=$joiners[0], joiner_value=joiner.value, tab_temp=comparaison.split(joiner_value),default_joiner={value:""}, 
			tab_conditions=tab_temp.map((el,i)=>{
				return {
					comparaison:el,
					next_joiner:comparaison.includes(joiner_value)?joiner:default_joiner};
			});

		for(joiner of $joiners.slice(1)){
			joiner_value=joiner.value;
			if(comparaison.includes(joiner_value)){
				tab_conditions=tab_conditions.map((cond,i)=>{
					tab_temp=cond.comparaison.split(joiner_value);
					return tab_temp.map((elt,j)=>{
						let next_joiner = i==tab_conditions.length-1 && j==tab_temp.length-1?
							default_joiner:
							j==tab_temp.length-1?
								cond.next_joiner:
								$joiners.filter(e=>e.value===joiner_value).pop();
						return {comparaison:elt,next_joiner:next_joiner};
					});
				}).flat(2);
			}
		}
		this.function=funct;
		this.tab_conditions=tab_conditions.map(cond=>{
			let comp=new Comparaison(cond.comparaison), 
				joiner=alt($joiners.filter(elt=>elt.value===cond.next_joiner.value).shift(),default_joiner);
			return new Comparaison({...comp,next_joiner:joiner});
		});	
	}
	toString(){
		return this.condition;
	}
	get condition(){
		return this.function+'('+this.tab_conditions.map(el=>el.exp).join('')+')';
	}
	set condition(condition){
		let cond=new Condition(condition);
		for (let el in cond) {
			this[el]=cond[el];
		}
	}

	add_comparaison(index){
		let i=index==-1?this.tab_conditions.length+1:index;
		this.tab_conditions.splice(i+1,0,new Comparaison(''));
	}
	remove_comparaison(i){
		this.tab_conditions.splice(i,1);
	}
}

module.exports=Condition;